import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import styles from "./houses.module.css";
import {
    FaBell, FaFacebookMessenger, FaStarOfLife, FaStar, FaTrash, FaHandHoldingWater,
    FaChalkboard, FaBath, FaLaptopHouse, FaBoxTissue, FaShower, FaWifi, FaToriiGate,
    FaChair, FaChessBoard, FaBed, FaMapMarkerAlt, FaPhoneAlt, FaHouseUser, FaShareSquare,
    FaArrowLeft
} from 'react-icons/fa';
import Backdrop from '@mui/material/Backdrop';
import { setsessionhouse, getsessionuser } from "../Utils/sessions";
import { isMobile, isTablet, isDesktop } from 'react-device-detect';
import MapComponent from "./mapcomponent";
import { Singlehouseurl } from "../Utils/urls";
import { primarycolor } from "../Utils/colors";
import SignIn from "../Common/login";
import {
    Button, Modal, Box, Typography, Paper, Chip, Grid, Divider,
    IconButton, Skeleton, Fade, CircularProgress, Tooltip
} from "@mui/material";
import { Helmet } from 'react-helmet';
import Sharepopup from "../Components/sharepopup";
import { calcdistance, formatprice, setFavicon } from "../Utils/functions";
import Houseimages from "../Components/houseimages";
import Reviews from "./review";
import { admindetails } from "../Utils/defaults";
import { campuscoordinates } from "../Utils/arrays";
import { PublishedWithChangesOutlined, LocationOn, Home, Share, Star, StarBorder, VerifiedOutlined, DirectionsWalkOutlined } from "@mui/icons-material";
import Upgradepopup from "../Components/upgradepopup";
import Universalheader from "../Headers/universalheader";

// ─── Design tokens — kept consistent with the redesigned listing cards ─────
const BRAND = '#900f20';
const BRAND_DARK = '#670600';
const BRAND_SOFT = 'rgba(144, 15, 32, 0.06)';
const INK = '#1c1a1a';
const GOLD = '#b8863b';
const CANVAS = '#f6f5f3';

const Viewsinglehouse = ({ onrefresh }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const id = location.pathname.split("/")[3];
    const sessionuser = getsessionuser();
    const [user, setuser] = useState(sessionuser && sessionuser);

    const [house, sethouse] = useState('');
    const [progress, setprogress] = useState(true);
    const [error, seterror] = useState('');
    const [display, setdisplay] = useState(false);
    const [facilities, setfacilities] = useState('');
    const [showloginpopup, setshowloginpopup] = useState(false);
    const [showloginpopup2, setshowloginpopup2] = useState(false);
    const [sharepopup, setsharepopup] = useState(false);
    const [reviewpopup, setreviewpopup] = useState(false);
    const [images, setimages] = useState();
    const [latitude, setlatitude] = useState('');
    const [longitude, setlongitude] = useState('');
    const url = "https://eazistey.co.ke/nav/viewsinglehouse/" + id;
    const [popupdiv, setpopupdiv] = useState(false);
    const [defaulturl, setdefaulturl] = useState('');
    const [hostelpaid, sethostelpaid] = useState(false);
    const [showupgradepopup, setshowupgradepopup] = useState(false);


    useEffect(() => {
        gethouse();
        getlocation()
    }, [])

    const getlocation = () => {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                setlatitude(position.coords.latitude)
                setlongitude(position.coords.longitude)
            },
            function (error) {
                // silently fail — location is optional
            }
        );
    }

    const gethouse = () => {
        setdisplay(false)
        seterror(null)
        axios.post(Singlehouseurl, { id: id }).then(response => {
            setprogress(false)
            if (!response.data.message) {
                const temphouse = response.data[0]
                checkpayment()
                setdisplay(true)
                sethouse(temphouse)
                setdefaulturl(temphouse.profilepic_url)
                setfacilities(temphouse.facilities[0])
                setimages([temphouse.profilepic_url, temphouse.pic1_url, temphouse.pic2_url, temphouse.pic3_url, temphouse.pic4_url])
                setFavicon(temphouse.profilepic_url)
                document.title = temphouse.housename
                document.querySelector('meta[name="description"]').setAttribute('content', `${temphouse.housename} ,Room type:${temphouse.type},Rent: ${temphouse.currency} ${formatprice(temphouse.price)} per sem,Location: ${temphouse.location}`);
            } else {
                setdisplay(false)
                seterror(response.data.message)
            }
        }).catch(error => {
            setprogress(false)
            seterror("Sorry there was an error. Try again later.")
        });
    }

    const checkpayment = () => {
        const userobject = sessionStorage?.getItem("user");
        let tempuser;
        if (userobject) {
            tempuser = JSON.parse(userobject)
            setuser(tempuser)
        }
        if (tempuser) {
            if (tempuser.currentplan == "Gold" || tempuser.currentplan == "Premium") {
                sethostelpaid(true)
            } else {
                if (tempuser?.hostelssubscribed) {
                    const hostelssubscribed = tempuser?.hostelssubscribed;
                    if (hostelssubscribed?.includes(id)) {
                        sethostelpaid(true)
                    }
                }
            }
        }
    }

    const startchat = () => {
        const url = `whatsapp://send?phone=${encodeURIComponent(house.phone)}&text=${encodeURIComponent(house.housename)}`;
        window.open(url, '_blank');
    }

    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const closepopupdiv = () => setpopupdiv(false);

    const defaultimage = "https://eazistey.co.ke/API_WEB_HOOKS/images/image2.png";

    const onsuccesslogin = () => {
        onrefresh()
        setsessionhouse(house.status === "Unapproved" ? admindetails : house)
        setshowupgradepopup(true)
    }

    const onsuccesslogin2 = () => {
        onrefresh()
        navigate('/nav/myproperties', { state: { message: "addproperty" } })
    }

    const onsuccessreview = () => {
        setreviewpopup(false)
        gethouse()
    }

    const gotomyproperties = () => {
        user ? navigate('/nav/myproperties', { state: { message: "addproperty" } }) : setshowloginpopup2(true)
    }

    const upgrade = () => {
        if (user) {
            setshowupgradepopup(true)
        } else {
            setshowloginpopup(true)
        }
    }

    const gotofund = () => navigate("/nav/mywallet")

    // Build amenity list from facilities
    const amenityList = facilities ? [
        { key: 'dustbin', label: 'Dustbin', icon: <FaTrash /> },
        { key: 'kitchensink', label: 'Kitchen Sink', icon: <FaHandHoldingWater /> },
        { key: 'bathroom', label: `Bathroom${facilities.bnumber ? ` (${facilities.bnumber})` : ''}`, icon: <FaBath /> },
        { key: 'balcony', label: 'Balcony', icon: <FaLaptopHouse /> },
        { key: 'ceiling', label: 'Ceiling', icon: <FaChalkboard /> },
        { key: 'toilet', label: `Toilet${facilities.tnumber ? ` (${facilities.tnumber})` : ''}`, icon: <FaBoxTissue /> },
        { key: 'hotshower', label: 'Hot Shower', icon: <FaShower /> },
        { key: 'router', label: 'Wi-Fi Router', icon: <FaWifi /> },
        { key: 'gate', label: 'Gate', icon: <FaToriiGate /> },
        { key: 'chair', label: 'Chair', icon: <FaChair /> },
        { key: 'tiles', label: 'Tiles', icon: <FaChessBoard /> },
        { key: 'matress', label: 'Mattress', icon: <FaBed /> },
        { key: 'bed', label: 'Bed', icon: <FaBed /> },
    ].filter(a => facilities[a.key] !== null && facilities[a.key] !== undefined) : [];

    const distanceFromCampus = house?.longitude ? calcdistance(house.latitude, house.longitude, campuscoordinates[0].latitude, campuscoordinates[0].longitude) : null;
    const walkMinutes = distanceFromCampus !== null && !isNaN(distanceFromCampus) ? Math.max(1, Math.round(distanceFromCampus * 12)) : null;

    return (
        <Box sx={{ bgcolor: CANVAS, minHeight: '100vh', pb: 8, fontFamily: "'Inter','Helvetica Neue',sans-serif" }}>
            {showupgradepopup && <Upgradepopup onsuccessplan={() => window.location.reload()} gotofund={gotofund} ondismiss={() => setshowupgradepopup(false)} hostelid={id} />}
            <Helmet>
                <link rel="icon" type="image/png" href={defaulturl} />
                <title>{house.housename}</title>
            </Helmet>

            {/* Modals */}
            <Modal open={reviewpopup} onClose={() => setreviewpopup(false)}>
                <Reviews reviews={house?.reviews} id={house.id} onsuccessreview={onsuccessreview} />
            </Modal>
            <Modal open={showloginpopup} onClose={() => setshowloginpopup(false)}>
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Modal>
            <Modal open={showloginpopup2} onClose={() => setshowloginpopup2(false)}>
                <SignIn onsuccesslogin={onsuccesslogin2} />
            </Modal>
            <Modal open={sharepopup} onClose={() => setsharepopup(false)}>
                <Sharepopup name={"Share property link through"} link={url} />
            </Modal>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={popupdiv} onClick={closepopupdiv}>
                <img src={defaulturl} style={{ width: isMobile ? "100%" : isDesktop ? 800 : 500, margin: "0 auto", height: isMobile ? 400 : isDesktop ? 600 : 500, borderRadius: 12 }} />
            </Backdrop>

            {/* Universalheader stays */}
            <Box sx={{ mb: 2 }}>
                <Universalheader />
            </Box>

            {/* Top Navigation Breadcrumb */}
            <Box sx={{ px: { xs: 2, md: 4 }, mb: 3, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <IconButton onClick={() => navigate(-1)} size="small" sx={{ bgcolor: 'white', border: '1px solid rgba(28,26,26,0.08)', '&:hover': { bgcolor: 'white', borderColor: BRAND } }}>
                    <FaArrowLeft size={14} color={INK} />
                </IconButton>
                <Typography variant="body2" sx={{ color: '#78726f', fontWeight: 500 }}>
                    <Box component="span" sx={{ color: BRAND, cursor: 'pointer', fontWeight: 600 }} onClick={() => navigate('/nav/home')}>Home</Box>
                    {' '}&rsaquo;{' '}
                    <Box component="span" sx={{ color: BRAND, cursor: 'pointer', fontWeight: 600 }} onClick={() => navigate(-1)}>Properties</Box>
                    {' '}&rsaquo;{' '}
                    <Box component="span" sx={{ color: INK, fontWeight: 600 }}>
                        {progress ? '...' : house.housename}
                    </Box>
                </Typography>
            </Box>

            {/* Error State */}
            {error && !progress && (
                <Box sx={{ px: { xs: 2, md: 4 }, py: 8, textAlign: 'center' }}>
                    <Typography variant="h6" sx={{ color: '#a13a2f', fontWeight: 700 }}>{error}</Typography>
                    <Button onClick={gethouse} sx={{ mt: 2, borderRadius: '10px', textTransform: 'none', fontWeight: 700 }} variant="outlined" color="error">Try Again</Button>
                </Box>
            )}

            {progress && (
                <Box sx={{ px: { xs: 2, md: 4 } }}>
                    <Skeleton variant="rounded" height={440} animation="wave" sx={{ borderRadius: '20px', mb: 3 }} />
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8}>
                            <Skeleton variant="text" animation="wave" sx={{ fontSize: '2rem', mb: 1 }} />
                            <Skeleton variant="text" animation="wave" width="60%" />
                            <Skeleton variant="rounded" animation="wave" height={130} sx={{ borderRadius: '14px', mt: 3 }} />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Skeleton variant="rounded" animation="wave" height={240} sx={{ borderRadius: '20px' }} />
                        </Grid>
                    </Grid>
                </Box>
            )}

            {display && !progress && (
                <Fade in={true} timeout={500}>
                    <Box sx={{ px: { xs: 2, md: 4 } }}>
                        {/* Title & Actions Row */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2.5, flexWrap: 'wrap', gap: 2 }}>
                            <Box>
                                <Typography sx={{ fontWeight: 700, color: INK, letterSpacing: '-0.02em', lineHeight: 1.15, fontSize: { xs: '1.5rem', md: '1.9rem' } }}>
                                    {house.housename}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mt: 1.25, flexWrap: 'wrap' }}>
                                    <Chip
                                        label={house.type}
                                        size="small"
                                        sx={{ bgcolor: BRAND_SOFT, color: BRAND, fontWeight: 700, height: 26 }}
                                    />
                                    {house.status === 'Approved' && (
                                        <Chip
                                            icon={<VerifiedOutlined sx={{ fontSize: '14px !important', color: `${GOLD} !important` }} />}
                                            label="Verified"
                                            size="small"
                                            sx={{ bgcolor: 'rgba(184,134,59,0.1)', color: GOLD, fontWeight: 700, height: 26 }}
                                        />
                                    )}
                                    <Box sx={{ display: 'flex', alignItems: 'center', color: '#78726f', gap: 0.5 }}>
                                        <LocationOn sx={{ fontSize: 17, color: '#9a9492' }} />
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>{house.location}</Typography>
                                    </Box>
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'center' }}>
                                <Tooltip title="List your property on Eazistey">
                                    <Button
                                        onClick={gotomyproperties}
                                        startIcon={<FaStarOfLife size={12} />}
                                        variant="outlined"
                                        size="small"
                                        disableRipple
                                        sx={{
                                            textTransform: 'none', fontWeight: 600, borderRadius: '10px',
                                            borderColor: 'rgba(28,26,26,0.16)', color: '#4a4544',
                                            '&:hover': { borderColor: BRAND, color: BRAND, bgcolor: BRAND_SOFT }
                                        }}
                                    >
                                        List on Eazistey
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Share this property">
                                    <IconButton
                                        onClick={() => setsharepopup(true)}
                                        sx={{ bgcolor: 'white', border: '1px solid rgba(28,26,26,0.08)', '&:hover': { borderColor: BRAND, bgcolor: BRAND_SOFT } }}
                                    >
                                        <FaShareSquare size={16} color={BRAND} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>

                        {/* Hero row: photo on the left, price + contact on the right —
                            each takes half the width instead of the photo running full-bleed
                            with empty space, and the contact card sitting in a tall sidebar */}
                        <Grid container spacing={3} sx={{ mb: 4 }}>
                            <Grid item xs={12} md={6}>
                                <Paper elevation={0} sx={{ borderRadius: '20px', overflow: 'hidden', height: '100%', border: '1px solid rgba(28,26,26,0.06)', cursor: 'pointer' }} onClick={() => setpopupdiv(true)}>
                                    <Box sx={{
                                        height: { xs: 260, md: 380 }, width: '100%', overflow: 'hidden', bgcolor: '#efece9',
                                        // Houseimages (swiper/img) doesn't always stretch on its own — force every
                                        // slide and image inside it to fill this box and crop with object-fit: cover
                                        // so a single photo (or fewer photos than slides) never leaves blank space.
                                        '& > *': { width: '100% !important', height: '100% !important' },
                                        '& img': { width: '100% !important', height: '100% !important', objectFit: 'cover' },
                                        '& .swiper, & .swiper-wrapper, & .swiper-slide': { width: '100% !important', height: '100% !important' },
                                    }}>
                                        <Houseimages imagesarray={images} />
                                    </Box>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        p: 3, borderRadius: '20px', height: '100%',
                                        border: '1px solid rgba(28,26,26,0.07)',
                                        bgcolor: 'white', display: 'flex', flexDirection: 'column'
                                    }}
                                >
                                    <Typography variant="caption" sx={{ color: '#9a9492', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.7px', mb: 2, display: 'block' }}>
                                        Contact & Details
                                    </Typography>

                                    {/* Price display */}
                                    <Box sx={{ mb: 3, pb: 3, borderBottom: '1px solid rgba(28,26,26,0.06)' }}>
                                        <Typography sx={{ fontWeight: 800, color: BRAND, letterSpacing: '-0.02em', fontSize: '2rem', lineHeight: 1.1 }}>
                                            {house.currency}{' '}{formatprice(house.price)}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#78726f', fontWeight: 500 }}>per semester</Typography>
                                    </Box>

                                    {!hostelpaid && (
                                        <Box>
                                            <Typography variant="body2" sx={{ color: '#78726f', mb: 2, lineHeight: 1.6 }}>
                                                Upgrade your plan to view contact details and get directions to this property.
                                            </Typography>
                                            <Button
                                                fullWidth
                                                onClick={upgrade}
                                                startIcon={<PublishedWithChangesOutlined />}
                                                variant="contained"
                                                disableElevation
                                                disableRipple
                                                sx={{
                                                    borderRadius: '12px', py: 1.6, textTransform: 'none', fontWeight: 700,
                                                    bgcolor: BRAND,
                                                    '&:hover': { bgcolor: BRAND_DARK }
                                                }}
                                            >
                                                Unlock Contact & Location
                                            </Button>
                                        </Box>
                                    )}

                                    {hostelpaid && (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                            <a href={`tel:${house.phone}`} style={{ textDecoration: 'none' }}>
                                                <Button
                                                    fullWidth
                                                    startIcon={<FaPhoneAlt />}
                                                    variant="contained"
                                                    disableElevation
                                                    disableRipple
                                                    sx={{
                                                        borderRadius: '12px', py: 1.6, textTransform: 'none', fontWeight: 700,
                                                        bgcolor: BRAND,
                                                        '&:hover': { bgcolor: BRAND_DARK }
                                                    }}
                                                >
                                                    Call Caretaker
                                                </Button>
                                            </a>
                                            <Button
                                                fullWidth
                                                onClick={startchat}
                                                startIcon={<FaFacebookMessenger />}
                                                variant="outlined"
                                                disableRipple
                                                sx={{
                                                    borderRadius: '12px', py: 1.6, textTransform: 'none', fontWeight: 700,
                                                    borderColor: 'rgba(144, 15, 32, 0.3)',
                                                    color: BRAND,
                                                    '&:hover': { borderColor: BRAND, bgcolor: BRAND_SOFT }
                                                }}
                                            >
                                                WhatsApp Chat
                                            </Button>
                                        </Box>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>

                        {/* Remaining details, full width below the hero row */}
                        {/* Key Details Cards */}
                        <Box sx={{ display: 'flex', gap: 1.5, mb: 4, flexWrap: 'wrap' }}>
                            {[
                                { label: 'Room Type', value: house.type },
                                { label: 'Price / Semester', value: `${house.currency} ${formatprice(house.price)}` },
                                { label: 'Landmark', value: house.landmark || 'N/A' },
                                ...(walkMinutes !== null ? [{ label: 'Walk to Campus', value: walkMinutes <= 20 ? `${walkMinutes} min` : `${distanceFromCampus} km` }] : []),
                            ].map((item, i) => (
                                <Paper key={i} elevation={0} sx={{ flex: '1 1 150px', p: 2.25, borderRadius: '16px', border: '1px solid rgba(28,26,26,0.07)', bgcolor: 'white' }}>
                                    <Typography variant="caption" sx={{ color: '#9a9492', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.7px', fontSize: '0.68rem' }}>
                                        {item.label}
                                    </Typography>
                                    <Typography sx={{ fontWeight: 700, color: i === 1 ? BRAND : INK, mt: 0.4, fontSize: i === 1 ? '1.15rem' : '0.98rem' }}>
                                        {item.value}
                                    </Typography>
                                </Paper>
                            ))}
                        </Box>

                        {/* Amenities */}
                        {amenityList.length > 0 && (
                            <Box sx={{ mb: 4 }}>
                                <Typography sx={{ fontWeight: 700, color: INK, mb: 2, fontSize: '1.1rem' }}>
                                    Amenities
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.25 }}>
                                    {amenityList.map((amenity, i) => (
                                        <Paper key={i} elevation={0} sx={{
                                            display: 'flex', alignItems: 'center', gap: 1, px: 1.75, py: 1.1,
                                            borderRadius: '12px', border: '1px solid rgba(28,26,26,0.07)',
                                            bgcolor: 'white', transition: 'all 0.2s ease',
                                            '&:hover': { borderColor: BRAND, bgcolor: BRAND_SOFT }
                                        }}>
                                            <Box sx={{ color: BRAND, display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>{amenity.icon}</Box>
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#3a3634', fontSize: '0.85rem' }}>{amenity.label}</Typography>
                                        </Paper>
                                    ))}
                                </Box>
                            </Box>
                        )}

                        {/* Reviews Link */}
                        <Paper
                            elevation={0}
                            onClick={() => setreviewpopup(true)}
                            sx={{
                                p: 2.25, borderRadius: '16px', border: '1px solid rgba(28,26,26,0.07)',
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                cursor: 'pointer', transition: 'all 0.2s ease', mb: 4, bgcolor: 'white',
                                '&:hover': { borderColor: BRAND }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{ display: 'flex', gap: 0.4 }}>
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} color={house?.reviews?.length > 0 ? GOLD : '#e5e1de'} size={16} />
                                    ))}
                                </Box>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: INK }}>
                                    {house?.reviews?.length || 0} {house?.reviews?.length === 1 ? 'Review' : 'Reviews'}
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ color: BRAND, fontWeight: 700 }}>Read all &rarr;</Typography>
                        </Paper>

                        {/* Map Section */}
                        {hostelpaid && house?.longitude && (
                            <Box sx={{ mt: 4 }}>
                                <Paper elevation={0} sx={{ p: 3, borderRadius: '20px', border: '1px solid rgba(28,26,26,0.07)', bgcolor: 'white' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
                                        <Box>
                                            <Typography sx={{ fontWeight: 700, color: INK, mb: 0.4, fontSize: '1.05rem' }}>Where you'll be</Typography>
                                            <Typography variant="body2" sx={{ color: '#78726f', fontWeight: 500 }}>
                                                {house.location}, {house.campus}, Kenya
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
                                            <Chip
                                                icon={<LocationOn sx={{ fontSize: 15 }} />}
                                                label={`${calcdistance(house.latitude, house.longitude, latitude, longitude)} km from you`}
                                                size="small"
                                                sx={{ bgcolor: 'rgba(28,26,26,0.05)', fontWeight: 600 }}
                                            />
                                            <Chip
                                                icon={<DirectionsWalkOutlined sx={{ fontSize: 15 }} />}
                                                label={`${distanceFromCampus} km from campus`}
                                                size="small"
                                                sx={{ bgcolor: 'rgba(184,134,59,0.1)', color: GOLD, fontWeight: 700 }}
                                            />
                                            <a href={`https://maps.google.com/?q=${house.latitude},${house.longitude}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                <Chip
                                                    label="Get Directions"
                                                    size="small"
                                                    clickable
                                                    sx={{ bgcolor: BRAND, color: 'white', fontWeight: 700, '&:hover': { bgcolor: BRAND_DARK } }}
                                                />
                                            </a>
                                        </Box>
                                    </Box>
                                    <Box sx={{ borderRadius: '14px', overflow: 'hidden', mt: 2 }}>
                                        <MapComponent longitude={house.longitude} latitude={house.latitude} />
                                    </Box>
                                </Paper>
                            </Box>
                        )}
                    </Box>
                </Fade>
            )}
        </Box>
    )
}

export default Viewsinglehouse;